import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@/lib/i18n";
import { App } from "@/App";
import { createFlagProvider } from "@athena/config/flags";
import { initSentry } from "@/lib/sentry";
import "@/styles/globals.css";

initSentry();

/**
 * Feature flags are resolved before the first paint.
 *
 * The provider is built with an anonymous context because Auth0 has not resolved yet; `useFlagIdentity`
 * re-targets it once the signed-in person is known, which is what lets a flag be rolled out to one
 * organization at a time. A missing client id yields a pass-through provider so local development
 * without LaunchDarkly still runs on the declared defaults.
 */
const FlagProvider = await createFlagProvider(import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID, {});

const rootElement = document.getElementById("root");
if (!rootElement) {
    throw new Error("Root element not found. Ensure index.html contains <div id='root'>.");
}

createRoot(rootElement).render(
    <StrictMode>
        <FlagProvider>
            <App />
        </FlagProvider>
    </StrictMode>,
);
